import { Box, Flex, Image, Spacer, Text } from '@chakra-ui/react';
import useSetArticleReaction from 'hooks/modules/articles/useSetArticleReaction';
import useAppTheme from 'hooks/shared/useAppTheme';
import _ from 'lodash';
import moment from 'moment';
import AppCard from 'presentation/components/shared/card/AppCard';
import ReactionsRow from 'presentation/components/shared/ReactionsRow';
import TagsRow from 'presentation/components/shared/TagsRow';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import documentIcon from 'assets/img/icons/document.svg';
import downloadFile from 'presentation/utils/downloadFile';
import { getFileSizeString } from 'presentation/utils/getFileSize';
import { FaEye } from 'react-icons/fa';

interface Props {
  article: ArticleListItem;
  inactive?: boolean;
}

const PrivateChannelArticleShortCard: FC<Props> = ({
  article,
  inactive = false,
}) => {
  const theme = useAppTheme();

  const navigate = useNavigate();

  const setReaction = useSetArticleReaction(
    article.id,
    article.selectedReactionId,
    1
  );

  const card = (
    <AppCard w="352px" h="324px" overflow="hidden">
      <Box h="160px" w="full" mb="8px">
        <Image
          src={article.image?.url}
          h="160px"
          w="full"
          objectFit="cover"
        />
      </Box>
      <Box pb="15px" px="15px">
        <Flex>
        <Text mb="2px" fontSize="14px">
          {moment(article.publicDate).format('DD.MM.yyyy')}
        </Text>
        <Spacer />
        <Box display="flex" alignItems="center">
          <FaEye color="grey" width="15px" height="10px" />
          <Text ml="5px" fontSize={14} color="grey">
            {article.viewCount}
          </Text>
        </Box>
        </Flex>
        <Text mb="20px" noOfLines={2} fontSize="18px" fontWeight={800}>
          {article.name}
        </Text>
        {article.tags && (
          <TagsRow
            tagColor={theme.colors[Color.Primary500]}
            tags={article.tags}
            mb="10px"
          />
        )}
        {article.presentation != null && (
          <Flex mb="16px" gap="8px">
            <Image src={documentIcon} w="37px" h="37px"
                   onClick={() => downloadFile(article.presentation?.url ?? '')} />
            <Box alignItems="center">
              <Text fontWeight="bold" fontSize={16}>{article.presentation.fileName}</Text>
              <Text fontWeight="normal" fontSize={12}>{getFileSizeString({
                bytes: article.presentation.size ?? 0,
                decimals: 2,
              })}</Text>
            </Box>
          </Flex>)}
        <ReactionsRow
          inactive={inactive}
          reactions={_.take(article.reactions, 4)}
          selectedReactionId={article.selectedReactionId}
          selectReaction={setReaction}
        />
      </Box>
    </AppCard>
  );

  if (inactive) {
    return card;
  }

  return (
    <Box
      onClick={() =>
        navigate(AppRoute.privateChannelArticleComments(article.id, article.isCommentable))
      }
      cursor="pointer"
    >
      {card}
    </Box>
  );
};

export default PrivateChannelArticleShortCard;
